import {createAction, createReducer, PayloadAction} from '@reduxjs/toolkit';

import {PayerInfoType, PayerOptionsType, PayerType} from 'desktop/types/payerInfoType';

export const initialState: PayerType = {
    info: {},
    options: {
        agreement: true,
        installments: '3',
        isSaveCard: false,
        subscribe: true,
    },
};

export const sendPayerInfoToSaga = createAction<PayerInfoType>('CHECKOUT@SEND_PAYER_INFO_TO_SAGA');

export const setPayerInfo = createAction<PayerInfoType>('CHECKOUT@SET_PAYER_INFO');

export const setPayerOptions = createAction<PayerOptionsType>('CHECKOUT@SET_PAYER_OPTIONS');

export const clearPayerInfo = createAction('CHECKOUT@CLEAR_PAYER_INFO');

/**
 * payerInfo reducer
 *
 * @return {PayerType} - payer Info state
 */
export const payerInfo = createReducer(initialState, builder =>
    builder
        .addCase(clearPayerInfo, () => ({...initialState}))
        .addCase(setPayerInfo, (state, action) => ({
            ...state,
            info: action.payload,
        }))
        .addCase(setPayerOptions, (state, action: PayloadAction<PayerOptionsType>) => ({
            ...state,
            options: {...state.options, ...action.payload},
        })),
);
